import React from 'react';
import { Button, message, Spin } from 'antd';
import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';
import { fetchData } from '../../middleware/fetchData';
import NoData from '../../image/none.png';
import noWxWarnIcon from '../../image/noWxWarnIcon.png';
import './index.less';
import { getIsWxClient } from '../../utils/commonUtils';
import codeBg from '../../image/codeBg.png';
import codeBtn from '../../image/codeBtn.png';
import { wxAuthorize } from '../../utils/wxUtils';
/*
    客服活码展示页面
*/
class CustomerServiceCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            noWxFlag: false,
            isSecurityAdd: 'Y',
            weChatAuthAfter: false,
            dynamicAddress: {}
        };
    }

    componentDidMount () {
        if (!getIsWxClient()) {
            this.setState({ noWxFlag: true });
            return;
        }
        this.handleInitStep();
    }

    handleInitStep = () => {
        const search = window.location.search;
        if (search.includes('code=')) {
            const searchArr = search.slice(1, search.length).split('&');
            const companyId = (searchArr.find(item => item.includes('companyId')) || '').replace('companyId=', '');
            const code = (searchArr.find(item => item.includes('code=')) || '').replace('code=', '');
            const appId = (searchArr.find(item => item.includes('appId=')) || '').replace('appId=', '');
            if (code === sessionStorage.code) {
                sessionStorage.isGrant = 'Y';
                this.setState({ weChatAuthAfter: true });
                this.handleGetCustomerCodeDetail();
                return;
            }
            // 重定向进来的 code给后端 返回unionId
            fetchData('/scrm-base/pass/queryUserInfoByCode', {
                body: JSON.stringify({ code, companyId, appId })
            }).then((res) => {
                if (res && res.code === 200) {
                    const { unionId, headImgUrl, nickname, province, city, country, sex, externalUserId } = res.data;
                    sessionStorage.code = code;
                    unionId && (sessionStorage.unionId = unionId);
                    headImgUrl && (sessionStorage.headImgUrl = headImgUrl);
                    nickname && (sessionStorage.nickname = nickname);
                    province && (sessionStorage.province = province);
                    city && (sessionStorage.city = city);
                    country && (sessionStorage.country = country);
                    sex && (sessionStorage.sex = sex);
                    externalUserId && (sessionStorage.externalUserId = externalUserId || '');
                    sessionStorage.isGrant = 'Y';
                    this.setState({ weChatAuthAfter: true });
                    this.handleGetCustomerCodeDetail();
                }
            });
        } else {
            // 刚跳进来后获取URL上携带参数 codeId 活码id companyId 公司id channelId 渠道id
            const searchArr = search.slice(1, search.length).split('&');
            const companyId = (searchArr.find(item => item.includes('companyId')) || '').replace('companyId=', '');
            const codeId = (searchArr.find(item => item.includes('codeId')) || '').replace('codeId=', '');
            const channelId = (searchArr.find(item => item.includes('channelId')) || '').replace('channelId=', '');
            const phone = (searchArr.find(item => item.includes('phone')) || '').replace('phone=', '');
            const followUserId = (searchArr.find(item => item.includes('followUserId')) || '').replace('followUserId=', '');
            const campPeriodId = (searchArr.find(item => item.includes('campPeriodId')) || '').replace('campPeriodId=', '');
            // 存储url上的参数
            companyId && (sessionStorage.companyId = companyId);
            codeId && (sessionStorage.codeId = codeId);
            channelId && (sessionStorage.channelId = channelId);
            phone && (sessionStorage.phone = phone);
            followUserId && (sessionStorage.followUserId = followUserId);
            campPeriodId && (sessionStorage.campPeriodId = campPeriodId);
            // 判断是否需要公众号授权
            fetchData('/scrm-wechat/pass/isCustomerGrant', {
                body: JSON.stringify({ companyId, codeId })
            }).then((response) => {
                if (response.data.isGrant === 'Y') {
                    sessionStorage.isGrant = 'Y';
                    this.setState({
                        dynamicAddress: { fixDomain: response.data.fixDomain }
                    })
                } else {
                    sessionStorage.isGrant = '';
                    this.handleGetCustomerCodeDetail();
                }
            });
        }
    }

    // 跳转授权
    jumpToWeChatAuth = () => {
        // 1.公司id去拿公众号授权参数 appid component_appid
        fetchData('/scrm-base/pass/queryAppInfo', {
            body: JSON.stringify({ companyId: sessionStorage.companyId, scene: 'CODE', businessId: sessionStorage.codeId })
        }).then((res) => {
            if (res && res.code === 200) {
                const { appId, platformAppId } = res.data;
                const { fixDomain } = this.state.dynamicAddress;
                wxAuthorize({
                    companyId: sessionStorage.companyId,
                    scene: 'CODE',
                    businessId: sessionStorage.codeId,
                    appId,
                    platformAppId,
                    fixDomain
                });
            }
        });
    }

    // 获取客服码的详情
    handleGetCustomerCodeDetail = () => {
        const search = window.location.search;
        const searchArr = search.slice(1, search.length).split('&');
        let params = {};
        if (sessionStorage.isGrant === 'Y') {
            params = {
                unionId: sessionStorage.unionId,
                headImg: sessionStorage.headImgUrl,
                nickName: sessionStorage.nickname,
                province: sessionStorage.province,
                city: sessionStorage.city,
                country: sessionStorage.country,
                sex: sessionStorage.sex,
                externalUserId: sessionStorage.externalUserId
            };
        }
        searchArr.forEach(item => {
            let itemArr = [item.slice(0, item.indexOf('=')), item.slice(item.indexOf('=') + 1, item.length)];
            if (['codeId', 'companyId', 'channelId', 'phone', 'followUserId', 'campPeriodId'].includes(itemArr[0])) {
                itemArr[1] && (itemArr[1] !== 'undefined') && (params[itemArr[0]] = decodeURIComponent(itemArr[1]));
            }
        });
        fetchData('/scrm-wechat/pass/customerCodeDetail', {
            body: JSON.stringify({ ...params })
        }).then((res) => {
            const { name } = res.data || {};
            document.title = name || '';
            this.setState({
                ...(res.data || {}),
                loading: false,
            });
        });
    }

    onTouchStart = () => {
        const { messageKey = '' } = this.state;
        const search = window.location.search;
        const searchArr = search.slice(1, search.length).split('&');
        let params = {};
        if (sessionStorage.isGrant === 'Y') {
            params = {
                unionId: sessionStorage.unionId,
                headImg: sessionStorage.headImgUrl,
                nickName: sessionStorage.nickname,
                province: sessionStorage.province,
                city: sessionStorage.city,
                country: sessionStorage.country,
                sex: sessionStorage.sex,
                externalUserId: sessionStorage.externalUserId
            };
        }
        searchArr.forEach(item => {
            let itemArr = item.split('=');
            if (['codeId', 'companyId', 'channelId', 'phone', 'followUserId', 'campPeriodId'].includes(itemArr[0])) {
                itemArr[1] && (itemArr[1] !== 'undefined') && (params[itemArr[0]] = decodeURIComponent(itemArr[1]));
            }
        });
        this.timeOutEvent = setTimeout(() => {
            this.timeOutEvent = 0;
            // 长按了
            if (messageKey) {
                fetchData('/scrm-wechat/pass/customerCodePress', {
                    body: JSON.stringify({ messageKey, ...params })
                }).then((res) => {
                    console.log('长按统计=>成功');
                });
            } else {
                console.log('缺少messageKey');
            }
        }, 400);
    }

    onTouchMove = () => {
        clearTimeout(this.timeOutEvent);
        this.timeOutEvent = 0;
    }
    onTouchEnd = () => {
        clearTimeout(this.timeOutEvent);
        if (this.timeOutEvent !== 0) {
            // 点击了
        }
        return false;
    }

    handleDeleteTips = () => {
        this.setState({
            isSecurityAdd: 'N',
        });
    }

    renderQrCodeContent = () => {
        const {
            qrCode = '', // 二维码地址
            messageKey = '', // 消息key
            isBlack = 'N', // 是否拉黑
            isSecurityAdd = 'Y', // 是否添加安全验证提示(Y是N否）
            name, //活码名称
            guideWords = '', // 引导语
            loading,
        } = this.state;
        return (
            loading ? <Spin spinning={true} style={{ width: '100%', marginTop: '200px' }} /> : isBlack === 'Y' || !qrCode ? (
                <div className="no-data">
                    <img src={NoData} alt="" />
                    <div className="text">抱歉，由于活动参与人数过多，请稍后重试</div>
                </div>
            ) : (
                <React.Fragment>
                    {isSecurityAdd === 'Y' ? (
                        <div className="safe-tips">
                            <div>
                                <CheckCircleFilled style={{ color: '#16C96D', fontSize: '0.14rem' }} />
                                <span className="tips">此二维码已通过安全验证，可以放心扫描 </span>
                            </div>
                            <CloseOutlined style={{ color: '#16C96D', fontSize: '0.14rem' }} onClick={() => this.handleDeleteTips()} />
                        </div>
                    ) : null}
                    <div className="main-content">
                        <div className="code-name">{guideWords}</div>
                        <div className="code-line">
                            <span className="left-line"></span>
                            <span className="point"></span>
                            <span className="right-line"></span>
                        </div>
                        <div className="qrcode-content">
                            <img src={qrCode} alt="" className="qrcode" onTouchStart={this.onTouchStart} onTouchMove={this.onTouchMove} onTouchEnd={this.onTouchEnd} />
                        </div>
                    </div>
                </React.Fragment>
            )
        )
    }

    renderQrCodeContentNeedAuth = () => {
        const {
            isSecurityAdd
        } = this.state;
        return (
            <React.Fragment>
                {isSecurityAdd === 'Y' ? (
                    <div className="safe-tips">
                        <div>
                            <CheckCircleFilled style={{ color: '#16C96D', fontSize: '0.14rem' }} />
                            <span className="tips">此二维码已通过安全验证，可以放心扫描 </span>
                        </div>
                        <CloseOutlined style={{ color: '#16C96D', fontSize: '0.14rem' }} onClick={() => this.handleDeleteTips()} />
                    </div>
                ) : null}
                <div className="main-content">
                    <div className="code-name"></div>
                    <div className="code-line">
                        <span className="left-line"></span>
                        <span className="point"></span>
                        <span className="right-line"></span>
                    </div>
                    <div className="qrcode-content">
                        <img src={codeBg} alt="" className="codeBg" />
                        <div className='code-btn-content'>
                            <img src={codeBtn} alt="" className="codeBtn" onClick={() => this.jumpToWeChatAuth()} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render () {
        const {
            noWxFlag,
            weChatAuthAfter,
        } = this.state;
        return (
            <div className="wechat-customer-code-content">
                {
                    noWxFlag ? <div className="no-data">
                        <img src={noWxWarnIcon} alt="" style={{ height: 'auto' }} />
                        请在微信客户端打开
                    </div> : (
                        sessionStorage.isGrant === 'Y' && !weChatAuthAfter ? (
                            this.renderQrCodeContentNeedAuth()
                        ) : (
                            this.renderQrCodeContent()
                        )
                    )
                }
            </div>
        );
    }
}

export { CustomerServiceCode };